import { HeroBannerContentType } from 'types/generated/graphql';
import { log } from 'utils/log';
import { SlideTypes } from '../types';
import { EventIds } from '../../../constants';

const getTypeFromContentType = (
    contentType: HeroBannerContentType,
): SlideTypes => {
    switch (contentType) {
        case 'Pack':
            return SlideTypes.Packs;
        case 'Custom':
            return SlideTypes.Custom;
        case 'Collection':
            return SlideTypes.Repacks;
        case 'Label':
            return SlideTypes.Labels;
        default:
            log.error(
                'An unknown HeroBannerContentType was provided',
                EventIds.UnknownHeroBannerContentType,
                new Error('An unknown HeroBannerContentType was provided'),
                {
                    contentType: contentType,
                },
            );

            return SlideTypes.Packs;
    }
};

export default getTypeFromContentType;
